import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { List, ListItem } from "@mui/material";
import "../../assets/css/footer.css";
import NavBarLandingPage from "./NavBarLandingPage";
import TermsConditionVector from "../../assets/images/termsandconditionvector.png";
import FooterLandingpage from "./FooterLandingpage";
function Cancellation() {
  const stylesMain = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.5rem",
      fontWeight: 700,
      lineHeight: "100%",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2.2rem",
        lineHeight:"100%"
      },
    },
  };
  const styles = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      fontSize: "2.5rem",
      fontWeight: 600,
      lineHeight: "25px",
      letterSpacing: "0em",
      textAlign: "left",
      "@media (max-width: 600px)": {
        fontSize: "2.5rem",
        lineHeight: "48px",
        marginTop: "0px",
      },
    },
  };
  const description = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: 18,
      fontWeight: 400,
      lineHeight: "28px",
      letterSpacing: "0em",
      textAlign: "left",
      
      "@media (max-width: 600px)": {
        fontSize: "1rem", // Adjust the font size for smaller screens
        lineHeight: "26px", // Adjust other styles as needed
        textAlign: "start",
      },
    },
  };
  return (
    <div>
      <NavBarLandingPage />
      <div className="cancellation-and-refund-background landing-page">
        <Box
          sx={{
            backgroundColor: "#1E53E8",
            borderRadius: "30px",
            padding: "3rem",
            margin: "40px",
            position: "relative",
            "@media (max-width: 1024px)": {
              margin: "32px",
              padding:"30px"
            },
            "@media (max-width: 600px)": {
              padding: "1.5rem",
              margin: "0px",
              borderRadius: "22px",
            },
            
          }}
        >
          <Typography
            sx={{
              ...stylesMain.typography,
              color: "#fff",
              textTransform: "uppercase",
              // marginTop: "30px",
              height: "50px",
            }}
          >
            Cancellation and Refund policy
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: "#FFFFFF",
              // marginTop: "12px",
              "@media (max-width: 600px)": {
        fontSize: "1rem", // Adjust the font size for smaller screens
        lineHeight: "26px", // Adjust other styles as needed
        marginTop:"40px"
      },
            }}
          >
            This policy outlines the terms and conditions for cancellation and
            refunds related to MegaConnect Cloud PC products and services.
          </Typography>
          <img
            src={TermsConditionVector}
            alt=""
            style={{ position: "absolute", right: "0", bottom: "0" }}
          />
        </Box>
        <Box
          sx={{
            borderRadius: "30px",
            backgroundColor: " #F1F1F1",
            padding: "3rem",
            marginTop: "2rem",
            marginBlockEnd: "6rem",
            margin: "40px",
            "@media (max-width: 1024px)": {
              margin: "32px",
              padding: "30px",
            },
            "@media (max-width: 600px)": {
              padding: "1.8rem",
              margin: "0px",
              borderRadius: "22px",
              marginTop:"20px"
            },
          }}
        >
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "10px" }}
          >
            Megaconnect Cloud PC{" "}
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginTop: "12px" }}>
                You may cancel your purchase of a MegaConnect Cloud PC within 15
                days of delivery and receive a full refund, provided the Device
                is in perfect condition and returned with all original packaging
                and accessories.
              </li>
              <li style={{ marginTop: "6px" }}>
                To initiate a cancellation, please contact our customer support
                team within the 15-day window. We will then guide you through
                the return process and provide instructions for safe and secure
                return of the Device.
              </li>

              <li style={{ marginTop: "6px" }}>
                Once we receive and inspect the returned Device and confirm its
                condition, we will process your refund within 5 business days.
                The refund will be issued to the original payment method used
                for the purchase.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Services and Subscription
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: "#000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginTop: "12px",listStyleType: "disc"  }}>
                All purchases of MegaConnect Cloud services and subscriptions,
                including monthly plans, additional storage, and other add-ons,
                are considered pay-per-use and non-refundable. This means that
                once you pay for a service or subscription, you are not entitled
                to a refund, regardless of usage or cancellation.
              </li>
              <li style={{ marginTop: "6px",listStyleType: "disc"  }}>
                This policy applies to all cloud services and subscriptions
                offered by MegaConnect, including but not limited to:
                <ul>
                  <li style={{ marginTop: "6px",listStyleType: "disc"  }}>
                    Monthly subscription plans
                  </li>
                  <li style={{ marginTop: "6px",listStyleType: "disc"  }}>
                    Additional Cloud Storage purchases
                  </li>
                  <li style={{ marginTop: "6px",listStyleType: "disc"  }}>
                    Enhanced processing power upgrades
                  </li>
                  <li style={{ marginTop: "6px",listStyleType: "disc"  }}>Software licenses</li>
                  <li style={{ marginTop: "6px",listStyleType: "disc"  }}>Data transfer fees</li>
                </ul>
              </li>
            </ul>
          </Typography>

          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Additional Information{" "}
          </Typography>
          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginBottom: "10px" }}>
                This policy does not apply to any third-party software licenses
                or subscriptions purchased through the MegaConnect platform.
                Please refer to the respective software providers' terms and
                conditions for information on their cancellation and refund
                policies.
              </li>

              <li style={{ marginTop: "18px" }}>
                We reserve the right to modify this policy at any time. We will
                notify you of any changes by posting the revised policy on our
                website. Your continued use of our services after such
                modifications constitutes your acceptance of the revised policy.
              </li>
            </ul>
          </Typography>
          <Typography
            sx={{ ...styles.typography, color: "#1E53E8", marginTop: "40px" }}
          >
            Contact Us
          </Typography>

          <Typography
            sx={{
              ...description.typography,
              color: " #000000",
              marginTop: "16px",
            }}
          >
            <ul>
              <li style={{ marginBottom: "10px" }}>
                If you have any questions about this policy or need assistance
                with cancellation or refunds, please contact our customer
                support team at 6360003712 or support@megaconnect.cloud
              </li>

              <li style={{ marginTop: "18px" }}>
                By using MegaConnect Cloud PC products and services, you
                acknowledge that you have read and understood this cancellation
                and refund policy.
              </li>
            </ul>
          </Typography>
        </Box>
      </div>
      <FooterLandingpage />
    </div>
  );
}

export default Cancellation;
